import { render, staticRenderFns } from "./ReceiveDeliveryItemDetails.vue?vue&type=template&id=75996578&scoped=true&"
import script from "./ReceiveDeliveryItemDetails.vue?vue&type=script&lang=ts&"
export * from "./ReceiveDeliveryItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiveDeliveryItemDetails.vue?vue&type=style&index=0&id=75996578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75996578",
  null
  
)

export default component.exports